/* eslint-disable import/prefer-default-export */
import {Types} from '../../request';
import ApiTag from '../apiTags';

// API docs ref - #74
// Input
// {
//     }

export const getTickerText = () => {
  return {
    url: '/commons/Ticker',
    payload: {},
    type: Types.POST,
    tag: ApiTag.TICKER_TEXT,
    headers: {},
    authRequired: false
  };
};
